import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Grid, Tab, Menu } from 'semantic-ui-react';
import { isMobile } from 'react-device-detect';

import { APP_NAME, ADMIN_LOGS } from '../../../utils/constant';
import SystemChange from '../systemLogs/index';
import EmailLogs from '../emailLogs/EmailLogs';
import { find } from '../../../utils/lodash';

import '../admin.scss';

const Logs = (props) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const { match } = props;
    const tab = find(ADMIN_LOGS, (o) => o.route === match?.params?.type);

    if (!match?.params?.type || !tab) {
      // empty "type" - navigate to first tab's route so the URL is correct
      // (currentTab is already 0, as required)
      navigate(getFullRoute(ADMIN_LOGS[0].route));
    } else {
      // set initial tab based on url param "type" if not tab 0 (the default tab)
      if (tab?.id > 0) {
        setCurrentTab(tab.id);
      }
    }
  });

  const getFullRoute = (tabRoute) => `/admin/logs/${tabRoute}`;

  const generateTabs = () => {
    document.title = `${t('admin.logs.logs')} | ${APP_NAME}`;

    return [
      {
        menuItem: t('admin.logs.system_logs'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <SystemChange />
          </Menu.Item>
        ),
      },
      {
        menuItem: t('admin.logs.email_logs'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <EmailLogs />
          </Menu.Item>
        ),
      },
    ];
  };

  const onTabClick = (data) => {
    changeRoute(data.activeIndex);
  };

  const changeRoute = async (value) => {
    try {
      const tab = find(ADMIN_LOGS, (o) => {
        return o.id === value || o.route === value;
      });
      if (!tab) {
        return false;
      }
      navigate(getFullRoute(tab.route));
      setCurrentTab(tab.id);
    } catch (error) {
      console.error('Logs ~ changeRoute ~ error', error);
      return false;
    }
  };

  return (
    <Grid.Row>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={generateTabs()}
        className={isMobile ? 'custom-tabs-mobile' : 'custom-tabs-admin'}
        activeIndex={currentTab}
        onTabChange={(e, data) => onTabClick(data)}
      />
    </Grid.Row>
  );
};

export default Logs;
